module.exports = __webpack_public_path__ + "img/haufe-akademie.a38fd67b.svg";